export const tpnGridData={
    columns:[
        {field:'id',hide:'true'},
        {field:'fileName',headerName:'File Name', width:200, editable:false, sortable:false, headerClassName:'tpnTableHeader'},
        {field:'imageType',headerName:'Image Type',width:200, editable:false, sortable:false, headerClassName:'tpnTableHeader'}],
    rows:[{id:'0',fileName:'no file to select yet',imageType:'na',imageID:'na'},{id:'1',fileName:'no file to select yet',imageType:'na',imageID:'na'}]
}